import axios from './axios';
import get from './get';
import post from './post';
import patch from './patch';
import put from './put';
import deleteRequest from './delete';

export {
  axios,
  get,
  post,
  patch,
  put,
  deleteRequest,
};
